<template>
  <form id="subscribe-form" class="subscribe__form subscribe-form" @submit="subscribeEmail">
    <div class="form-group form-group--column form-group--subscribe">
      <EmailInput
        class="subscribe-form__input-wrap"
        @getValue="handleEmail"
        @blur="checkEmail"
        @onFocus="focusEmail"
        :email-value="email"
        :error-text="errorMessage"
      />
    </div>
    <Button @click.native="subscribeEmail"
            native-type="submit"
            type="transparent"
            size="max-content">{{ $t('button.subscribe') }}</Button>
    <div class="agree-terms agree-terms--subscribe">
      <p class="agree-terms__text">
        {{ $t('agreement.text') }}
        <a href="/terms-and-conditions/"
           target="_blank"
           class="link agree-terms-link">{{ $t('agreement.link') }}</a>
      </p>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EmailInput from '../inputs/EmailInput'
import axios from 'axios'
import Button from '../inputs/Button'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'SubscribeForm',
  components: {
    Button,
    EmailInput
  },
  data () {
    return {
      isValidEmail: false,
      isError: false,
      email: '',
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      userData: state => state.user.user_data
    })
  },
  methods: {
    handleEmail (e) {
      const { value, isValid } = e

      this.email = value
      this.isValidEmail = isValid
    },
    checkEmail () {
      if (!this.email.length) {
        this.errorMessage = this.$t('subscribe_empty')
        this.isError = true
        this.isValidEmail = false
      } else if (!this.isValidEmail) {
        this.errorMessage = this.$t('subscribe_error')
        this.isError = true
      }
    },
    focusEmail () {
      this.isError = false
      this.errorMessage = ''
    },
    subscribeEmail (e) {
      e.preventDefault()
      this.checkEmail()

      if (this.isValidEmail) {
        const postParams = new URLSearchParams()
        postParams.append('NewsletterSubscriber[email]', this.email)

        axios
          .post(this.urlLanguagePrefix + '/site/subscribe/', postParams)
          .then(res => {
            if (res.data.success) {
              if (res.data?.user_data?.user_id) {
                this.$store.commit('UPDATE_USER_DATA', res.data.user_data)
                GoogleEnhancedEcommerce.rememberExternalUserId(res.data.user_data.user_id)
              }
              this.notify(res.data.message, 'success')
              GoogleEnhancedEcommerce.emailSubscription({
                userId: res.data?.user_data?.user_id || this.userData?.user_id || '',
                email: this.email
              })
              this.email = ''
            } else {
              this.notify(res.data.message, 'error')
            }
          })
          .catch(err => {
            this.notify(err.response.data.message, 'error')
          })
      }
    },
    notify (message, type) {
      this.$notify({
        group: type,
        title: type === 'error' && this.$t('error'),
        text: message,
        type: type
      })
    }
  }
}
</script>

<style scoped lang="sass">

.subscribe-form__input-wrap
  margin-bottom: 10px
  height: 55px

.subscribe__form
  margin-top: 15px

  +mmax(768)
    margin-top: 20px

.subscribe-form
  +mmax(375)
    width: 100%

</style>
